export default "__VITE_ASSET__CjoTnlnP__"